import http from '../utils/http.js'

export function pageQuery(data){
    return http.post(`/enterpriseQualification/pageQuery/${data.page}/${data.size}`, data)
}
export function frontPageQuery(data){
    return http.post(`/enterpriseQualification/front/pageQuery/${data.page}/${data.size}`, data)
}
export function add(data){
    return http.post(`/enterpriseQualification/add`, data)
}
export function update(data){
    return http.put(`/enterpriseQualification/update`, data)
}
export function del(ids){
    return http.delete(`/enterpriseQualification/del`, ids)
}